import {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {updateShippingMethod} from 'desktop/pages/checkout/store/reducers/deliveryStep/shippingMethods/shippingMethods';
import {finishDeliveryStep} from 'desktop/pages/checkout/store/reducers/sagaStep/sagaStep';
import {getShippingMethodList} from 'desktop/pages/checkout/store/selectors/shippingMethods/shippingMethods';
import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

/**
 * Update shipping method if it is available
 */
export const useUpdateShippingMethod = () => {
    const {selectedShippingMethod} = useIsOneStepAvailable();

    const availableShippingMethods = useSelector(getShippingMethodList);

    const dispatch = useDispatch();

    useEffect(() => {
        if (availableShippingMethods.length && selectedShippingMethod) {
            const hasSelectedMethod = availableShippingMethods.some(
                method => method.code === selectedShippingMethod,
            );
            if (hasSelectedMethod) {
                dispatch(updateShippingMethod(selectedShippingMethod));
            }
            dispatch(finishDeliveryStep());
        }
    }, [availableShippingMethods, dispatch, selectedShippingMethod]);
};
